import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=fa0cd732&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=fa0cd732&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0cd732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa0cd732')) {
      api.createRecord('fa0cd732', component.options)
    } else {
      api.reload('fa0cd732', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=fa0cd732&scoped=true", function () {
      api.rerender('fa0cd732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/ViewForm.vue"
export default component.exports